
export default {
	name: "SecondaryLoadingSpinner",
	props: {
		label: {
			type: String,
			default: "Loading…",
		},
	},
};
